import React from 'react';
import 'lazysizes';
import 'lazysizes/plugins/parent-fit/ls.parent-fit';
import Slide from 'react-reveal/Slide';

import {SectionTitle} from 'component/reuse/title';


function Card(props) {
  const card = props.card;
  return (
    <div className="my-3">
      <Slide>
      <div className="card-body text-black-2">
        <h3 className="family-h4 card-text my-4">{card.name}</h3>
        <div className="" style={{display: 'grid', justifyItems: 'center', alignItems: 'center'}}>
          <div className="rounded img img-fluid">
            <img className="lazyload" data-src={card.image_url} alt={card.description} style={{width: '200px', height: '240px'}}/>  
          </div>
        </div>
        <p className="text-size-1 family-code text-justify card-text my-4" dangerouslySetInnerHTML={{__html: card.description }}></p>
      </div>
      </Slide>
    </div>
  )
}

export default class How extends React.Component {
  render (){
    const categories = [
      {
        name: "1. Get API key",
        image_url: '/static/images/how/one.svg',
        description: 'Create an <a href="/instructions#tut-create-api">API key</a> for your site. Just enter your site name and we\'ll create a key for you. You can create as many sites as you want.',
      },
      {
        name: "2. Record your show",
        image_url: '/static/images/how/two.svg',
        description: 'Use the Divshow builder with your API key to <a href="/instructions#tut-record">record and upload a show</a>. It\'s a 1 line javascript import and just requires you to speak and move your mouse.',
      },
      {
        name: "3. Play your show",
        image_url: '/static/images/how/three.svg',
        description: 'Replace the builder script tag with DivShow player code to <a href="/instructions#tut-play">play your show</a>',
      },
    ]
    return (
      <section id="how" className="content-section flex-center my-5">
        <div className="container-fluid">
          <div className="" style={{display: 'grid', justifyItems: 'center', alignItems: 'center'}}>
            <SectionTitle first="How it works" second="" background="quaternary" flip={false} />

            <div className='row text-center'>
              {categories.map(function(category, idx){
                return(
                  <div className='col-xl col-lg-4 col-md-4 col-sm-12 ' key={"i_" + idx}>
                      <Card card={category} />
                  </div>
                )
              })}
            </div>
          </div>
        </div>
      </section>
    )
  }
}